import { BookOpen, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { HELP_CENTER_URLS } from '@/constants/helpCenter';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Card linking to the per-language help center.
 */
export function HelpCenterCard() {
  const { t, language } = useLanguage();
  const helpUrl = HELP_CENTER_URLS[language];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BookOpen className="h-5 w-5" />
          {t.support.helpCenter.title}
        </CardTitle>
        <CardDescription>{t.support.helpCenter.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button variant="outline" asChild>
          <a href={helpUrl} target="_blank" rel="noopener noreferrer">
            {t.support.helpCenter.open}
            <ExternalLink className="ml-2 h-4 w-4" />
          </a>
        </Button>
      </CardContent>
    </Card>
  );
}
